<h1 id="qpp">Pension RRQ</h1>

<div class="card">
  <div class="card-body d-flex gap-3">
    <magieno-input-number-field [advancedFormControl]="this.qppPensionForm.formElements.deathAge | asAdvancedFormControl"
                                [locale]="this.locale"></magieno-input-number-field>

    <magieno-input-rate-field
            [advancedFormControl]="this.qppPensionForm.formElements.qPPIncreasingRate | asAdvancedFormControl"
            [locale]="this.locale"
    ></magieno-input-rate-field>

    <magieno-input-rate-field [advancedFormControl]="this.qppPensionForm.formElements.investmentRate | asAdvancedFormControl"
                              [locale]="this.locale"
    ></magieno-input-rate-field>
  </div>
</div>


